module.exports = __webpack_public_path__ + "img/16-Plant Automation Technology.70a5be52.png";